module.exports = __webpack_public_path__ + "img/Pot3.cb7cc715.svg";